import React, { useEffect } from 'react';
import styled from 'styled-components';

import { ProgressButton } from 'src/components/progress-button/progress-button';
import BasketSuccess from 'src/assets/basket-success-icon';
import { Typography } from 'src/typography';
import { useCountdownTimer } from 'src/hooks/use-countdown-timer';

type ErrorContentProps = {
  onClose: () => void;
};

export function ErrorContent({ onClose }: ErrorContentProps): JSX.Element {
  const { secondsLeft, startTimer } = useCountdownTimer({
    initialSeconds: 10,
    onTimerStop: onClose,
  });

  useEffect(() => {
    startTimer();
  }, [startTimer]);

  return (
    <Content data-testid='error-content'>
      <BasketSuccess />
      <TextContainer>
        <Heading tag='h1' size='large'>
          Your order is being prepared,
          <br />
          finalize payment at the counter
        </Heading>
      </TextContainer>
      <ButtonContainer>
        <ProgressButton
          secondsLeft={secondsLeft}
          totalSeconds={10}
          onClose={onClose}
          buttonText={`Close (${secondsLeft.toString()})`}
          timerText=''
        />
      </ButtonContainer>
    </Content>
  );
}

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces[8]};
  justify-content: center;
  margin-top ${({ theme }) => theme.spaces[6]};
  width: 100%;
  text-align: center;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces[2]};
`;

const Heading = styled(Typography.Heading)`
  color: ${({ theme }) => theme.colors.primaryBlack};
  font-weight: 700;
  text-align: center;
`;

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces[2]};
  width: 100%;
`;
